export default "__VITE_ASSET__B7VkbxE7__"